import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  IdentityVerificationMethod,
  SsoAccountCheckoutState,
  SsoAccountData,
  SsoAccountFacade,
  SessionStorageKey,
  SessionStorageState,
} from 'common';
import { ProductCode, LoanData } from '../../../loan/domain/models/loan.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifp-account-setup-begin',
    templateUrl: './account-setup-begin.component.html',
    styleUrls: ['./account-setup-begin.component.scss'],
    standalone: false
})
export class AccountSetupBeginComponent implements OnInit {
  data: AccountSetupBeginComponentData;
  checkoutState: SsoAccountCheckoutState;
  continueEnabled = true;
  productCodes = ProductCode;
  readonly IdentityVerificationMethod = IdentityVerificationMethod;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly ssoAccountFacade: SsoAccountFacade
  ) {
    SessionStorageState.set(SessionStorageKey.AccountSetupViewed, true);
  }

  ngOnInit(): void {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe((it: AccountSetupBeginComponentData) => {
        this.data = it;
        this.handleIdVerseCompletedCallback();
      });
    this.initCheckoutState();
  }

  private initCheckoutState(): void {
    this.ssoAccountFacade.getSsoAccountCheckoutState$()
      .pipe(untilDestroyed(this))
      .subscribe((checkoutState: SsoAccountCheckoutState) => {
        this.checkoutState = checkoutState;
      });
  }

  continue() {
    this.continueEnabled = false;
    const loanId = this.data?.loan?.id;
    const navigationExtras = { replaceUrl: true, queryParams: { loanId } }
    
    this.router
      .navigate(['account', 'setup', 'verify-identity'], navigationExtras)
      .finally(() => {
        this.continueEnabled = true;
      });
  }

  private handleIdVerseCompletedCallback(): void {
    if (SessionStorageState.get(SessionStorageKey.IdVerseCompletedCallback) !== true) {
      return;
    }

    this.continue();
  }
}

export interface AccountSetupBeginComponentData {
  currentAccount: SsoAccountData;
  loan: LoanData;
}
